/**
 * Tên mô hình để HIỆN CHO NGƯỜI ĐỌC, tách khỏi mã định danh — port nguyên `ten-model.ts` của native.
 *
 * Câu người dùng hỏi ở ô chọn mô hình là "đang dùng bên nào" (việc thật là so hai bên trên cùng một câu hỏi), không
 * phải mã `qwen3.6-35b-a3b`. Mã vẫn thấy được ở dòng mô tả — hạ xuống một bậc, không giấu.
 *
 * Bảng chứ không `toUpperCase()`: viết hoa máy móc cho `foxai` ra `FOXAI`, sai chính tên riêng của họ.
 */
const TEN: Record<string, string> = {
  foxai: 'FoxAI',
  gemini: 'Gemini',
  anthropic: 'Anthropic',
  openai: 'OpenAI',
};

export function tenNhaCungCap(provider: string): string {
  const k = (provider || '').trim().toLowerCase();
  if (!k) return '';
  return TEN[k] ?? k.charAt(0).toUpperCase() + k.slice(1);
}

/** Khoá GỬI LÊN của một mục. Hai mục Gemini cùng `provider`, nên khoá là `id`; máy chủ cũ thiếu `id` thì rơi về `provider`. */
export function khoaModel(m: { id?: string; provider: string }): string {
  return m.id || m.provider;
}

export function nhanModel(m: { nhan?: string; provider: string; id?: string }): string {
  return m.nhan || nhanTuKhoa(khoaModel(m));
}

/**
 * `gemini@gemini-3.6-flash` → `Gemini 3.6`. Bộ ĐỊNH DẠNG cho khoảng chờ `/health` chưa về (antd hiện thẳng `value`
 * khi chưa có mục khớp), không phải bảng tên thứ hai — cái nào máy chủ có thì cái ấy thắng.
 */
export function nhanTuKhoa(khoa: string): string {
  const [provider = '', model = ''] = (khoa || '').split('@');
  const ten = tenNhaCungCap(provider);
  const ban = model.match(/\d+(?:\.\d+)?/)?.[0];
  return ban ? `${ten} ${ban}` : ten;
}

/**
 * Tên hiện ở nút bấm khi CHƯA ai chọn gì. Dò không ra thì trả về chính mã ấy, đừng đoán: một cái tên trông như thật
 * cho sai nhà cung cấp tệ hơn một mã khó đọc.
 */
export function tenMacDinh(
  model: string | undefined,
  models: { provider: string; model: string; nhan?: string; macDinh?: boolean }[] | undefined,
): string {
  if (!model) return '';
  const m = models?.find((x) => x.macDinh) ?? models?.find((x) => x.model === model);
  return m ? nhanModel(m) : model;
}

const TEN_CONG_KHAI_MAC_DINH = 'FoxAI';

/** Tên cho NGƯỜI DÙNG CUỐI. Vắng thì rơi về tên chung, KHÔNG rơi về tên thật — rơi về tên thật là lộ thứ phải giấu. */
export function tenCongKhai(m: { tenCongKhai?: string } | undefined): string {
  return m?.tenCongKhai || TEN_CONG_KHAI_MAC_DINH;
}

/** `tenMacDinh` cho người dùng cuối: dò không ra thì KHÔNG trả mã thô. */
export function tenCongKhaiMacDinh(
  model: string | undefined,
  models: { model: string; tenCongKhai?: string; macDinh?: boolean }[] | undefined,
): string {
  return tenCongKhai(models?.find((x) => x.macDinh) ?? models?.find((x) => x.model === model));
}

/**
 * Khoá của mục ĐANG LÀ mặc định máy chủ. Máy chủ đánh dấu bằng `macDinh`; máy chủ cũ thì dò theo `model` và ưu tiên
 * mục trơn (không ghim bản) — gửi nó lên là "theo mặc định máy chủ".
 */
export function khoaMacDinh(
  model: string | undefined,
  models: { id?: string; provider: string; model: string; macDinh?: boolean }[] | undefined,
): string {
  const co = models?.find((x) => x.macDinh);
  if (co) return khoaModel(co);
  if (!model || !models) return '';
  const trung = models.filter((x) => x.model === model);
  const tron = trung.find((x) => !khoaModel(x).includes('@'));
  const chon = tron ?? trung[0];
  return chon ? khoaModel(chon) : '';
}
